import axios from 'axios';

// Same-origin por padrão: em produção o Caddy serve o frontend e faz proxy de
// /api → backend; em dev, o proxy do CRA (campo "proxy" no package.json) encaminha
// /api para o backend em localhost:5000. Dá para sobrescrever via REACT_APP_API_URL.
const api = axios.create({ baseURL: process.env.REACT_APP_API_URL || '/api' });

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  res => res,
  err => {
    if (err.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('usuario');
      window.location.href = '/login';
    }
    return Promise.reject(err);
  }
);

export default api;
